//styles
import * as S from './NonRefundanbleComponent.styles';

export default function NonRefundableComponent({data, style = {}, title = ''}) {
  return (
    <S.Cancel_policy_wrap style={style}>
      {title && (
        <S.BaseColumnWrap>
          <S.Text_Heading>{title}</S.Text_Heading>
        </S.BaseColumnWrap>
      )}
      <S.CancelList_Wrap>
        {data?.cancelRules?.map((rule, index) => (
          <li key={index}>
            <S.Left_wrap />
            <S.BaseColumnWrap>
              <S.Text_Head dangerouslySetInnerHTML={{__html: rule?.text}} />
            </S.BaseColumnWrap>
          </li>
        ))}
      </S.CancelList_Wrap>
    </S.Cancel_policy_wrap>
  );
}
